import Vue from 'vue';
import VueRouter from 'vue-router';
import { applyPlugin } from '~/lib.js';
import { registerPagesStore } from '~/store.js';

Vue.use(VueRouter);
const initOption = {
  base: '/',
  mode: 'hash',
  routes: [
    {
      name: 'Im',
      meta: { name: '在线工作台' },
      path: '/im',
      component: () =>
        import(
          /* webpackChunkName: 'Im_layout.vue' */ '../pages/im/_layout.vue'
        )
    },
    {
      name: 'page403',
      path: '/403',
      component: () =>
        import(/* webpackChunkName: 'page403' */ '../pages/403.vue')
    },
    {
      name: 'page500',
      path: '/500',
      component: () =>
        import(/* webpackChunkName: 'page500' */ '../pages/500.vue')
    },
    {
      name: 'ChatRecordAvatar',
      path: '/chatRecord/avatar',
      component: () =>
        import(
          /* webpackChunkName: 'ChatRecordAvatar' */ '../pages/chatRecord/avatar.vue'
        )
    },
    {
      name: 'ChatRecordBubblesBox',
      path: '/chatRecord/bubbles/box',
      component: () =>
        import(
          /* webpackChunkName: 'ChatRecordBubblesBox' */ '../pages/chatRecord/bubbles/box.vue'
        )
    },
    {
      name: 'ChatRecordBubblesImage',
      path: '/chatRecord/bubbles/image',
      component: () =>
        import(
          /* webpackChunkName: 'ChatRecordBubblesImage' */ '../pages/chatRecord/bubbles/image.vue'
        )
    },
    {
      name: 'ChatRecordBubblesOrder',
      path: '/chatRecord/bubbles/order',
      component: () =>
        import(
          /* webpackChunkName: 'ChatRecordBubblesOrder' */ '../pages/chatRecord/bubbles/order.vue'
        )
    },
    {
      name: 'ChatRecordBubblesText',
      path: '/chatRecord/bubbles/text',
      component: () =>
        import(
          /* webpackChunkName: 'ChatRecordBubblesText' */ '../pages/chatRecord/bubbles/text.vue'
        )
    },
    {
      name: 'ChatRecord',
      path: '/chatRecord',
      component: () =>
        import(
          /* webpackChunkName: 'ChatRecord' */ '../pages/chatRecord/index.vue'
        )
    },
    {
      name: 'ChatRecordNotice',
      path: '/chatRecord/notice',
      component: () =>
        import(
          /* webpackChunkName: 'ChatRecordNotice' */ '../pages/chatRecord/notice.vue'
        )
    },
    {
      name: 'ChatRecordSvg-icon',
      path: '/chatRecord/svg-icon',
      component: () =>
        import(
          /* webpackChunkName: 'ChatRecordSvg-icon' */ '../pages/chatRecord/svg-icon.vue'
        )
    },
    {
      name: 'Debug',
      path: '/debug',
      component: () =>
        import(/* webpackChunkName: 'Debug' */ '../pages/debug.vue')
    },
    {
      name: 'JumpPage',
      path: '/jumpPage',
      component: () =>
        import(/* webpackChunkName: 'JumpPage' */ '../pages/jumpPage.vue')
    },
    {
      name: 'Problem-maintenance',
      path: '/problem-maintenance',
      component: () =>
        import(
          /* webpackChunkName: 'Problem-maintenance' */ '../pages/problem-maintenance/index.vue'
        )
    },
    {
      name: 'Qa-settingsAddress-cascader',
      path: '/qa-settings/address-cascader',
      component: () =>
        import(
          /* webpackChunkName: 'Qa-settingsAddress-cascader' */ '../pages/qa-settings/address-cascader/index.vue'
        )
    },
    {
      name: 'Qa-settings',
      path: '/qa-settings',
      component: () =>
        import(
          /* webpackChunkName: 'Qa-settings' */ '../pages/qa-settings/index.vue'
        )
    },
    {
      name: 'page404',
      path: '*',
      component: () =>
        import(/* webpackChunkName: 'page404' */ '../pages/404.vue')
    }
  ]
};
applyPlugin('beforeRouterCreate', initOption);
const router = new VueRouter(initOption);
applyPlugin('afterRouterCreate', router);

export default router;
